// imports ...
import React, {
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
  useCallback,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Icon } from "semantic-ui-react";
import "../../App.css";
import MenuItemBubble from "../speeachBubbles/MenuItemBubble";
import SubMenuItemBubble from "../speeachBubbles/SubMenuItemBubble";
import RecievedMessageBubble from "../speeachBubbles/RecievedMessageBubble";
import SendMessageBubble from "../speeachBubbles/SendMessageBubble";
import { fetchNewChat } from "./data/newChat";
import { sendingMessage } from "./data/sendMessage";
import TextAreaInput from "../../app/common/form/TextAreaInput";
import BackMenuItemBubble from "../speeachBubbles/BackMenuItemBubble";

function AVAChatbox({ closeChatbox, isOpen }) {
  const [sendMessage, setSendMessage] = useState("");
  const [firstOpen, setFirstOpen] = useState(true);
  const [isMenuClick, setIsMenuClick] = useState(false);
  const [isSubMenuClick, setIsSubMenuClick] = useState(false);
  const [menuMessageID, setMenuMessageID] = useState(0);
  const [functionType, setFunctionType] = useState("");
  const [functionMessageOrder, setFunctionMessageOrder] = useState(null);
  const [noq, setNoq] = useState(null);
  const [renderedItems, setRenderedItems] = useState([]);
  const [messages, setMessages] = useState([]);
  const [formData, setFormData] = useState({
    messageID: 0,
    textMessage: "",
    messageType: "USER",
    isMenuItem: false,
    itemsAmount: 0,
  });

  const textareaRef = useRef(null);
  const chatContentRef = useRef(null);
  const iframeRef = useRef(null);
  const dispatch = useDispatch();

  const { data } = useSelector((state) => state.newChat);
  const { avaMessages, loadingAVAMessages } = useSelector(
    (state) => state.sendMessageSlice
  );

  useEffect(() => {
 
    if (isOpen && firstOpen) {
      setFirstOpen(false);
      dispatch(fetchNewChat());
    }
  }, [dispatch, isOpen, firstOpen]);

  useEffect(() => {
    if (data) {
      const newMessages = data.map((msg) => ({
        ...msg,
        renderID: `${msg.messageID}-${Date.now()}-${Math.random()}`,
      }));

      setMessages((prev) => [...prev, ...newMessages]);
    }
  }, [data]);

  useEffect(() => {
    if (avaMessages.length > 0) {
      const newMessages = avaMessages
        .filter(
          (newMsg) => !messages.some((msg) => msg.messageID === newMsg.messageID)
        )
        .map((msg) => ({
          ...msg,
          renderID: `${msg.messageID}-${Date.now()}-${Math.random()}`,
        }));

      if (newMessages.length > 0) {
        const lastMessage = newMessages[newMessages.length - 1];

        setFunctionType(lastMessage.functionType || "");
        setFunctionMessageOrder(lastMessage.functionMessageOrder);
        setNoq(lastMessage.noq);
      }

      setMessages((prev) => [...prev, ...newMessages]);
    }
  }, [avaMessages]);

  useEffect(() => {
    if (messages.length > renderedItems.length) {
      const newItems = messages.slice(renderedItems.length);
      renderWithDelay(newItems);
    }
  }, [messages]);

  const renderWithDelay = (newItems, index = 0) => {
    if (index < newItems.length) {
      setRenderedItems((prevItems) => {
        const isDuplicate = prevItems.some(
          (item) => item.renderID === newItems[index].renderID
        );
        return isDuplicate ? prevItems : [...prevItems, newItems[index]];
      });
      setTimeout(() => renderWithDelay(newItems, index + 1), 500);
    }
  };

  useLayoutEffect(() => {
    if (chatContentRef.current) {
      chatContentRef.current.scrollTop = chatContentRef.current.scrollHeight;
    }
  }, [renderedItems]);

  useEffect(() => {
    if (formData.textMessage === "" && textareaRef.current) {
      textareaRef.current.style.height = "30px";
    }
  }, [formData.textMessage]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    e.target.style.height = "auto";
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  const handleSendMessage = () => {
    if (formData.textMessage.trim()) {
      const newMessage = {
        message: formData.textMessage,
        messageID: messages.length + 1,
        renderID: `${messages.length + 1}-${Date.now()}-${Math.random()}`,
        messageType: "USER",
        functionType,
        functionMessageOrder,
        noq,
      };

      setMessages((prevMessages) => {
        const isDuplicate = prevMessages.some(
          (msg) => msg.messageID === newMessage.messageID
        );
        return isDuplicate ? prevMessages : [...prevMessages, newMessage];
      });

      setFormData({ ...formData, textMessage: "" });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.textMessage.trim()) {
      dispatch(
        sendingMessage({
          messageText: formData.textMessage,
          messageType: formData.messageType,
          isMenuItem: isMenuClick,
          messageID: formData.messageID,
          itemsAmount: messages.length,
          functionType,
          functionMessageOrder,
          noq,
        })
      );

      handleSendMessage();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (event.shiftKey) {
        event.preventDefault();
        setFormData((prevData) => ({
          ...prevData,
          textMessage: prevData.textMessage + "\n",
        }));
        adjustTextareaHeight();
      } else {
        event.preventDefault();
        handleSubmit(event);
      }
    }
  };

  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  const handleMenuItemClick = (
    messageText,
    messageType,
    messageID,
    itemsAmount
  ) => {
    setFormData((prevData) => ({
      ...prevData,
      textMessage: messageText,
      messageID,
      itemsAmount,
    }));
    setIsMenuClick(true);
    setIsSubMenuClick(false);
  };

  const getSubMenuItemClickHandler = useCallback(
    (messageText, messageType, messageID) => {
      return () => {
        setFormData((prevData) => ({
          isMenuItem: false,
          textMessage: messageText,
          messageID,
          messageType,
        }));
        setIsSubMenuClick(true);
        setIsMenuClick(false);
      };
    },
    []
  );

  useEffect(() => {
    if ((isMenuClick || isSubMenuClick) && formData.textMessage.trim()) {
      handleSubmit({ preventDefault: () => {} });
      setIsMenuClick(false);
    }
  }, [isMenuClick, isSubMenuClick]);

  const handleResetChat = () => {
    setSendMessage("");
    setIsMenuClick(false);
    setIsSubMenuClick(false);
    setMenuMessageID(0);
    setFunctionType("");
    setFunctionMessageOrder(null);
    setNoq(null);

    setFormData({
      messageID: messages.length,
      textMessage: "",
      messageType: "USER",
      isMenuItem: false,
      itemsAmount: messages.length,
    });

    dispatch(fetchNewChat(false));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className={`chatBox ${isOpen ? "open" : "closed"}`}>
        <div className="headerBox">
          <h2 className="headerTitle">Customer Service</h2>
          <Icon name="close" className="closeIcon" onClick={closeChatbox} />
        </div>
        <div className="chatContent" ref={chatContentRef}>
          {renderedItems.map((item) => (
            <div key={item.renderID}>
              {item.messageType === "MENU" && (
                <MenuItemBubble
                  messageText={item.message}
                  messageID={item.messageID}
                  onClick={() =>
                    handleMenuItemClick(
                      item.message,
                      item.messageType,
                      item.messageID,
                      renderedItems.length
                    )
                  }
                />
              )}
              {item.messageType === "SUBMENU" && (
                <SubMenuItemBubble
                  messageText={item.message}
                  messageID={item.messageID}
                  onClick={getSubMenuItemClickHandler(
                    item.message,
                    item.messageType,
                    item.messageID
                  )}
                />
              )}
              {item.messageType === "AVA" && (
                <RecievedMessageBubble messageText={item.message} />
              )}
              {item.messageType === "USER" && (
                <SendMessageBubble messageText={item.message} />
              )}
              {item.messageType === "RESET_BUTTON" && (
                <BackMenuItemBubble
                  messageText={item.message}
                  messageID={item.messageID}
                  onClick={handleResetChat}
                />
              )}
            </div>
          ))}

          {renderedItems.length === messages.length && messages.length > 0 && (
            <BackMenuItemBubble
              messageText="Back to main menu"
              messageID="reset-button"
              onClick={handleResetChat}
            />
          )}

          {loadingAVAMessages && (
            <div className="typingIndicator">
              {Array.from("   Typing...").map((letter, index) => (
                <span key={index} className="typingLetter">
                  {letter}
                </span>
              ))}
            </div>
          )}
        </div>
        <div className="chatInputContainer">
          <TextAreaInput
            ref={textareaRef}
            name="textMessage"
            value={formData.textMessage}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            setFocus={true}
          />
        </div>
        <Icon
          name={loadingAVAMessages ? "spinner" : "send"}
          className={`sendIcon ${loadingAVAMessages ? "spin-icon" : ""}`}
          onClick={!loadingAVAMessages ? handleSubmit : null}
          size="large"
          disabled={loadingAVAMessages}
        />
      </div>
    </form>
  );
}

export default AVAChatbox;
